
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

const IS_SIDEBAR_OPEN = 'is-sidebar-open';
const HAS_HEADER = 'has-header';

const state = {
    sidebarShow: false,
    hasHeader: true,
};

const getters = {
    getSidebarShowStatus: (state) => state.sidebarShow, 
    getHasHeaderStatus: (state) => state.hasHeader, 
};

const actions = { 
};

const mutations = {
    toggleSidebar(state) {
        const _width = window.innerWidth;
        const _maxWidth = 992;
        if (_width < _maxWidth || state.hasHeader) {
            state.sidebarShow = !state.sidebarShow;
            state.sidebarShow
                ? document.body.classList.add(IS_SIDEBAR_OPEN)
                : document.body.classList.remove(IS_SIDEBAR_OPEN);
        }
        if (state.hasHeader === false) {
            document.body.classList.remove(IS_SIDEBAR_OPEN);
            document.body.classList.remove(HAS_HEADER);
        } 

    },
    setSidebarShow(state, val) {
        state.sidebarShow = val;
    },
    setHasHeader(state, val) {
        state.hasHeader = val;
    },
    isHasHeader(state){
        if(state.hasHeader){
            document.body.classList.add(HAS_HEADER);
        }
    }
};

export const leftsidebar = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
